export const COMPARE_VERSIONS = {
  CLOSE_BUTTON: 'compare-versions-close-button',
  CANCEL_BUTTON: 'compare-versions-cancel-button',
  COMPARE_BUTTON: 'compare-versions-compare-button',
  TOOLTIP_TRIGGER: 'compare-versions-tooltip-trigger',
  VERSION_SELECT: 'compare-versions-version-select',
  COMPARISON_DROPDOWN_SELECT: 'compare-versions-comparison-dropdown-select',
  MASTER_SCHEDULE_CONTAINER: 'compare-versions-master-schedule-container',
  CHANGE_BUTTON: 'compare-versions-change-button',
  ASSIGN_BASELINE_BUTTON: 'compare-versions-assign-baseline-button',
  BASELINE_MENU_ITEM: 'compare-versions-baseline-menu-item',
  PREVIOUS_MENU_ITEM: 'compare-versions-previous-menu-item',
  OTHER_VERSIONS_MENU_ITEM: 'compare-versions-other-versions-menu-item',
  ASSIGN_BASELINE_MENU_ITEM: 'compare-versions-assign-baseline-menu-item'
} as const;
